// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantAccountActivityBreakdownRecordDto
 */
export interface IParticipantAccountActivityBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employment_status_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    plan_year_valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    plan_year_valid_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    account_balance?: number;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    enrollment_effective_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    enrollment_status?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    limited_use?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    enrollment_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employee_per_pay?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employer_per_pay?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    claim_spend?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    fee_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employee_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employer_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    total_contributions?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    individual_contributions?: number;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    rollover_in?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    rollover_out?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IParticipantAccountActivityBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IParticipantAccountActivityBreakdownRecordDto interface.
 */
export function instanceOfIParticipantAccountActivityBreakdownRecordDto(value: object): value is IParticipantAccountActivityBreakdownRecordDto {
    return true;
}

export function IParticipantAccountActivityBreakdownRecordDtoFromJSON(json: any): IParticipantAccountActivityBreakdownRecordDto {
    return IParticipantAccountActivityBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IParticipantAccountActivityBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantAccountActivityBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employment_status_date': json['employment_status_date'] == null ? undefined : (new Date(json['employment_status_date'])),
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_year_valid_from': json['plan_year_valid_from'] == null ? undefined : (new Date(json['plan_year_valid_from'])),
        'plan_year_valid_to': json['plan_year_valid_to'] == null ? undefined : (new Date(json['plan_year_valid_to'])),
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_balance': json['account_balance'] == null ? undefined : json['account_balance'],
        'enrollment_effective_date': json['enrollment_effective_date'] == null ? undefined : (new Date(json['enrollment_effective_date'])),
        'enrollment_status': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'limited_use': json['limited_use'] == null ? undefined : json['limited_use'],
        'enrollment_amount': json['enrollment_amount'] == null ? undefined : json['enrollment_amount'],
        'employee_per_pay': json['employee_per_pay'] == null ? undefined : json['employee_per_pay'],
        'employer_per_pay': json['employer_per_pay'] == null ? undefined : json['employer_per_pay'],
        'claim_spend': json['claim_spend'] == null ? undefined : json['claim_spend'],
        'fee_amount': json['fee_amount'] == null ? undefined : json['fee_amount'],
        'employee_contributions': json['employee_contributions'] == null ? undefined : json['employee_contributions'],
        'employer_contributions': json['employer_contributions'] == null ? undefined : json['employer_contributions'],
        'total_contributions': json['total_contributions'] == null ? undefined : json['total_contributions'],
        'individual_contributions': json['individual_contributions'] == null ? undefined : json['individual_contributions'],
        'rollover_in': json['rollover_in'] == null ? undefined : json['rollover_in'],
        'rollover_out': json['rollover_out'] == null ? undefined : json['rollover_out'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IParticipantAccountActivityBreakdownRecordDtoToJSON(json: any): IParticipantAccountActivityBreakdownRecordDto {
    return IParticipantAccountActivityBreakdownRecordDtoToJSONTyped(json, false);
}

export function IParticipantAccountActivityBreakdownRecordDtoToJSONTyped(value?: IParticipantAccountActivityBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employment_status': value['employment_status'],
        'employment_status_date': value['employment_status_date'] == null ? undefined : ((value['employment_status_date']).toISOString().substring(0,10)),
        'plan_year': value['plan_year'],
        'plan_year_valid_from': value['plan_year_valid_from'] == null ? undefined : ((value['plan_year_valid_from']).toISOString().substring(0,10)),
        'plan_year_valid_to': value['plan_year_valid_to'] == null ? undefined : ((value['plan_year_valid_to']).toISOString().substring(0,10)),
        'plan_name': value['plan_name'],
        'plan_code': value['plan_code'],
        'account_type': value['account_type'],
        'account_balance': value['account_balance'],
        'enrollment_effective_date': value['enrollment_effective_date'] == null ? undefined : ((value['enrollment_effective_date']).toISOString().substring(0,10)),
        'enrollment_status': value['enrollment_status'],
        'limited_use': value['limited_use'],
        'enrollment_amount': value['enrollment_amount'],
        'employee_per_pay': value['employee_per_pay'],
        'employer_per_pay': value['employer_per_pay'],
        'claim_spend': value['claim_spend'],
        'fee_amount': value['fee_amount'],
        'employee_contributions': value['employee_contributions'],
        'employer_contributions': value['employer_contributions'],
        'total_contributions': value['total_contributions'],
        'individual_contributions': value['individual_contributions'],
        'rollover_in': value['rollover_in'],
        'rollover_out': value['rollover_out'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

